import { render, staticRenderFns } from "./FeeChip.vue?vue&type=template&id=dcb44d5e&scoped=true&"
import script from "./FeeChip.vue?vue&type=script&lang=js&"
export * from "./FeeChip.vue?vue&type=script&lang=js&"
import style0 from "./FeeChip.vue?vue&type=style&index=0&id=dcb44d5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb44d5e",
  null
  
)

export default component.exports